import { useMapped } from "@omni/utils/context/mapped.context";
import { cn } from "tailwind-variants";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { useColorListContext } from "../../context/colorsList.context";

type Props = {
    className?: string;
};

const Family = ({ className }: Props) => {
    const { t } = useGranite();

    const { index } = useMapped();

    const { family, colors } = useColorListContext();

    if (index !== 0) return null;

    return (
        <div className={cn("tw:font-semibold tw:mb-1", className)}>
            <span
                style={{
                    backgroundColor: family.hex
                }}
                className={cn(
                    "tw:inline-block tw:mr-2 tw:w-3 tw:h-3 tw:rounded-full tw:relative"
                )}
            ></span>
            <span className={cn("tw:inline-block")}>{family.name}</span>
            <span className={cn("tw:font-light tw:text-sm tw:ml-2")}>
                {t(
                    `paintConfigurator.colors.family.nrOfColors.${colors.length > 1 ? "many" : "one"}`,
                    colors.length
                )}
            </span>
        </div>
    );
};

export { Family };
